<template>
  <div class="tab-body">
    <div class="operator">
      <el-row>
        <el-col :span="12" style="display: flex">
          <div style="display: flex">
            <el-select
              v-show="depts"
              v-model="chs_dpt"
              size="mini"
              @change="chgSelect(1)"
            >
              <el-option
                v-for="item in depts"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              >
              </el-option>
            </el-select>

            <el-select
              v-show="emps"
              size="mini"
              style="width: 110px"
              @change="chgSelect(2)"
              v-model="chs_emp"
            >
              <el-option
                v-for="item in emps"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span="12" style="display: flex">
          <div style="display: flex">
            <el-tag
              v-show="selected.length > 0"
              v-for="tag in tags"
              :key="tag.name"
              closable
              :type="tag.type"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData.records"
        align="center"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55px"
          fixed="left"
        ></el-table-column>

        <el-table-column width="110px" prop="mth" label="月份">
        </el-table-column>

        <el-table-column width="120px" prop="emp" label="销售人员">
        </el-table-column>

        <el-table-column width="180px" prop="dyzxfd" label="电邀-接访-辅导">
        </el-table-column>

        <el-table-column width="110px" prop="smgj" label="上门-跟进">
        </el-table-column>

        <el-table-column prop="cj" width="110px" label="成交数量">
        </el-table-column>

        <el-table-column width="100%" prop="tf" label="成交退费">
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="20"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/consu/consultation/consultation.js";
import apiIdx from "@/api/system/department/department.js";

export default {
  name: "consumthppr",
  data() {
    return {
      searchParams: {},
      listLoading: false,
      listData: [],

      selected: [],
      tags: [],

      depts: undefined,
      emps: undefined,
      chs_dpt: "",
      chs_emp: "",
      me: {},
      page: new this.$constant.pageObj(),
    };
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      api.listMth(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    },
    chgSelect(type) {
      if (type == 1) {
        //切换部门
        this.searchParams.type = this.chs_dpt;
        this.list();
      } else if (type == 2) {
        if ("全部人" == this.chs_emp) {
          delete this.searchParams.emp;
        } else {
          this.searchParams.emp = this.chs_emp;
        }
      }
      this.list();
    },
    //改变选择项
    selectionChange(val) {
      this.selected = val;

      if (this.selected.length > 0) {
        let a = 0,
          b = 0,
          c = 0,
          d = 0;
        for (let i = 0; i < this.selected.length; i++) {
          let v= this.selected[i]
          a += v.dyzxfd;
          b += v.smgj;
          c += v.cj;
          d += v.tf;
        }
        this.tags = [
          { name:   (this.chs_dpt=="1"?'电邀':(this.chs_dpt=="2"?'咨询接访':'技术辅导'))+ "合计:  " + a, type: "success", size: "mini" },
          { name: (this.chs_dpt=="1"?'上门':"跟进")+"合计:  " + b, type: "info", size: "mini" },
          { name: "成交合计:  " + c, type: "warning", size: "mini" },
          { name: "退费合计:  " + d, type: "danger", size: "mini" },
        ];
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.list();
    },
  },
  mounted() {
    this.me = this.$caches.user.get();

    if (
      this.me.role2 == "admin" ||
      this.me.role2 == "admin2" ||
      this.me.role2 == "mgr" ||
      this.me.role2 == "mgr2" ||
      this.me.role2 == "mgr3"
    ) {
      apiIdx.deptEmps({}, (res) => {
        this.emps = res.data.emps;

        if (
          this.me.role2 == "admin" ||
          this.me.role2 == "admin2" ||
          this.me.role2 == "mgr"
        ) {
          this.depts = [
            { val: "1", name: "电邀统计数据" },
            { val: "2", name: "咨询统计数据" },
            { val: "3", name: "技术支持统计" },
          ];
          this.chs_dpt = "2";
        }

        this.chs_emp = "全部人";

        this.list();
      });
    } else {
      this.list();
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>

